export default "__VITE_ASSET__C0_Croof__"